// pages/ContactPage.tsx
import { useState } from "react";

export default function ContactPage() {
    const [status, setStatus] = useState<"idle" | "sent">("idle");

    return (
        <div className="max-w-2xl mx-auto px-6 py-12">

            <title>Contact | Name Ninja</title>
            <meta name="description" content="Get in touch with the Name Ninja team for support or feedback." />


            <h1 className="text-3xl font-bold mb-6">📬 Contact Us</h1>
            <p className="text-gray-600 mb-6">
                Have a question, found a bug, or just want to say hi? Reach out and we’ll get back to you soon.
            </p>

            {status === "sent" ? (
                <div className="bg-green-100 text-green-800 p-4 rounded-lg">Thanks! Your message has been sent.</div>
            ) : (
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        setStatus("sent");
                    }}
                    className="space-y-4"
                >
                    <input
                        type="email"
                        required
                        placeholder="Your email"
                        className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                    <textarea
                        rows={5}
                        required
                        placeholder="Your message"
                        className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                    <button
                        type="submit"
                        className="bg-indigo-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-indigo-700 transition"
                    >
                        Send Message
                    </button>
                </form>
            )}
        </div>
    );
}
